import streetService from '@/services/streetService';
import { FETCH_STREETS, SET_STREETS } from './actions.type';

const initialState = {
  streets: [],
};

const streetModule = {
  state: () => initialState,
  getters: {
    streets(state) {
      return state.streets;
    },
  },
  actions: {
    async [FETCH_STREETS](context, search) {
      const { data } = await streetService.fetchStreets(search);
      context.commit(SET_STREETS, data.results);
    },
  },
  mutations: {
    [SET_STREETS](state, streets) {
      state.streets = streets;
    },
  },
};

export default streetModule;
